import React, { useState , useEffect } from 'react';
import Aux from 'components/hoc/AuxFunction';
import { Modal, message } from 'antd';

import { useSelector } from 'react-redux';
import moment from 'moment';
import CRUDDataTable from '../../components/DataTable/CRUDDataTable';
import ActionButtonsDropdown from 'components/ActionButtonsDropdown';
import { isCurrentPermissionKeyPermitted, permissifyTableColumns } from 'utils';
import { getAppointmentsDatatable, updateAppointmentStatus } from '../../api/appointments';
import {  getLocationTypeList } from '../../api/locations';

const { confirm } = Modal;

const CheckedInPatientList = (props) => {
    const permissionState = useSelector(state => state.permissions);
    const [draw, setDraw] = useState(0);
    const [isActionPerform, setActionPerform] = useState(false);
    const [locationType, setLocationType] = useState([]);
    useEffect(() => {
        (async () => {
            let responseLocType = await getLocationTypeList();
            setLocationType(responseLocType.data.data);
          })();
    }, []);


    const updateAppointmentConsultStatus = async (id, statusValue, text) => {
        try {
            if (statusValue) {
                const response = await updateAppointmentStatus({
                    id: id,
                    status: statusValue
                });

                setActionPerform(true);
                message.success(`Successfully ${text} consult.`);
            }
        } catch {
        } finally {
        }
    }

    const columns = [
        {
            permissionKey: 'checkinPatient:list:column:mrn',
            title: <strong>MRN</strong>,
            dataIndex: 'mrn',
            key: 'mrn',
            sorter: true
        },
        {
            permissionKey: 'checkinPatient:list:column:name',
            title: <strong>Patient Name</strong>,
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            render: (text, record, index) => {
                return (
                    <>
                        {record?.firstName} {record?.lastName}
                    </>
                );
            }
        },
        {
            permissionKey: 'checkinPatient:list:column:appointmentDateTime',
            title: <strong>Appointment Time & Date</strong>,
            dataIndex: 'appointmentDateTime',
            key: 'appointmentDateTime',
            sorter: true,
            render: (text, record, value) => moment(text).format('DD MMM YYYY h:mm A')
        },
        {
            permissionKey: 'checkinPatient:list:column:appointmentType',
            title: <strong>Appointment Type</strong>,
            dataIndex: 'appointmentType',
            key: 'appointmentType',
            sorter: true
        },
        {
            permissionKey: 'checkinPatient:list:column:doctorName',
            title: <strong>Clinician Name</strong>,
            dataIndex: 'attendingDoctorName',
            key: 'attendingDoctorName',
            sorter: true,
            filter: {
                paramName: 'doctorName',
                label: 'Clinician Name',
                component: {
                    name: 'text',
                    placeholder: 'Enter Clinician name'
                }
            }
        },
        {
            permissionKey: 'checkinPatient:list:column:status',
            title: <strong>Status</strong>,
            dataIndex: 'status',
            key: 'status',
            sorter: true
        },
        {
            permissionKey: 'checkinPatient:list:column:contactNumber',
            title: <strong>Contact Number</strong>,
            dataIndex: 'contactNumber',
            key: 'contactNumber',
            sorter: true
        },
        {
            permissionKey: 'checkinPatient:list:column:queueTime',
            title: <strong>Queue Time</strong>,
            dataIndex: 'queueTime',
            key: 'queueTime',
            sorter: true,
            render: (text, record, value) => moment.utc(parseInt(record?.queueTime)*1000).format('mm:ss')
        },
        {
            permissionKey: 'checkinPatient:list:column:waitTime',
            title: <strong>Wait Time</strong>,
            dataIndex: 'waitTime',
            key: 'waitTime',
            sorter: true,
            render: (text, record, value) => moment.utc(parseInt(record?.waitTime)*1000).format('mm:ss')
        },

        {
            permissionKey: 'checkinPatient:list:column:consultTime',
            title: <strong>Time in Consult</strong>,
            dataIndex: 'consultTime',
            key: 'consultTime',
            sorter: true,
            render: (text, record, value) => moment.utc(parseInt(text)*1000).format('mm:ss'),
        },
        {
            permissionKey: 'checkinPatient:list:column:actions',
            title: <strong>Actions</strong>,
            dataIndex: 'actions',
            key: 'actions',
            sorter: false,
            render: (text, record, value) => {
                let appointmentOptions = [];

                if(record.status !== 'START_CONSULT' && record.status !== 'END_CONSULT') {
                    appointmentOptions = [
                        ...appointmentOptions,
                        {
                            permissionKey: 'checkinPatient:list:column:actions:start_consult',
                            label: 'Start Consult',
                            onClick: () => {
                                setActionPerform(false);
                                confirm({
                                    title: 'Confirm',
                                    content: 'Are you sure you want to Start Consult?',
                                    okText: 'Yes',
                                    cancelText: 'No',
                                    maskClosable: true,
                                    onOk: () => {
                                        updateAppointmentConsultStatus(record.id, 'START_CONSULT', 'Start');
                                    }
                                });
                            }
                        }
                    ]
                }

                if(record.status !== 'END_CONSULT') {
                    appointmentOptions = [
                        ...appointmentOptions,
                        {
                            permissionKey: 'checkinPatient:list:column:actions:end_consult',
                            label: 'End Consult',
                            onClick: () => {
                                setActionPerform(false);
                                confirm({
                                    title: 'Confirm',
                                    content: 'Are you sure you want to End Consult?',
                                    okText: 'Yes',
                                    cancelText: 'No',
                                    maskClosable: true,
                                    onOk: () => {
                                        updateAppointmentConsultStatus(record.id, 'END_CONSULT', 'End');
                                    }
                                });
                            }
                        }
                    ]
                }
                
                // const permittedOptions = appointmentOptions.filter(appointmentOption => isCurrentPermissionKeyPermitted(appointmentOption.permissionKey, permissionState));
    
                return (
                    <>
                        <ActionButtonsDropdown
                            menus={appointmentOptions}
                        />
                    </>
                );
            },
        },
        {
            permissionKey: 'appointments:list:column:clinicType',
            filter: {
                paramName: 'clinicType',
                label: 'Clinic Type',
                component: {
                    name: 'select',
                    placeholder: 'Select a Clinic Type',
                    fetchData: () => {
                        return locationType.map((item) => {
                          return {
                            value: item.key,
                            displayText: item.display,
                          };
                        });
                    },
                  },
            },
        }
    ];

    const fetchAppointments = async(params) => {
        params = {
            ...params,
            sortColumn: 'id',
            checkedInPage: true
        }

        return await getAppointmentsDatatable(params);
    }
    if ( locationType.length === 0 ) {
        return null;
      }
    return (
        <Aux>
            <CRUDDataTable
                draw={draw}
                entity=''
                fetchDataFunction={fetchAppointments}
                continuousFetchInterval={60000}
                isActionPerform={isActionPerform}
                // columns={permissifyTableColumns(columns, permissionState)}
                columns={columns}
                sortOrder='name'
                button={<></>}
                highlightRow={(rec, i) => {
                    return (<></>);
                }}
            />
        </Aux>
    );
};

export default CheckedInPatientList;
